import { buildApiCall } from '@he-novation/config/apis/api-fetch';
import {
    API_CUSTOM_FIELD_OPTIONS,
    API_CUSTOM_FIELDS
} from '@he-novation/config/apis/custom-field-api';
import {
    CreateCustomFieldBody,
    CreateCustomFieldOptionBody,
    UpdateCustomFieldBody,
    UpdateCustomFieldOptionBody
} from '@he-novation/config/types/payloads/custom-field.payload';

export const asyncCustomFieldsFetch = (workspaceName: string) =>
    buildApiCall(API_CUSTOM_FIELDS.LIST)({ params: { workspaceName } });

export const asyncCustomFieldCreate = (workspaceName: string, body: CreateCustomFieldBody) =>
    buildApiCall(API_CUSTOM_FIELDS.POST)({ params: { workspaceName }, body });

export const asyncCustomFieldUpdate = (
    workspaceName: string,
    customFieldUuid: string,
    body: UpdateCustomFieldBody
) => buildApiCall(API_CUSTOM_FIELDS.PATCH)({ params: { workspaceName, customFieldUuid }, body });

export const asyncCustomFieldDelete = (workspaceName: string, customFieldUuid: string) =>
    buildApiCall(API_CUSTOM_FIELDS.DELETE)({ params: { workspaceName, customFieldUuid } });

export const asyncCustomFieldOptionCreate = (
    workspaceName: string,
    customFieldUuid: string,
    body: CreateCustomFieldOptionBody
) =>
    buildApiCall(API_CUSTOM_FIELD_OPTIONS.POST)({
        params: { workspaceName, customFieldUuid },
        body
    });

export const asyncCustomFieldOptionUpdate = (
    workspaceName: string,
    customFieldUuid: string,
    customFieldOptionUuid: string,
    body: UpdateCustomFieldOptionBody
) =>
    buildApiCall(API_CUSTOM_FIELD_OPTIONS.PATCH)({
        params: { workspaceName, customFieldUuid, customFieldOptionUuid },
        body
    });

export const asyncCustomFieldOptionDelete = (
    workspaceName: string,
    customFieldUuid: string,
    customFieldOptionUuid: string
) =>
    buildApiCall(API_CUSTOM_FIELD_OPTIONS.DELETE)({
        params: { workspaceName, customFieldUuid, customFieldOptionUuid }
    });
